import { tv } from "../../../variants/tv.js";
const moduleStatsVariants = tv({
    slots: {
        gridWrapper: '@container w-full',
        grid: 'grid gap-6',
        statItem: 'flex flex-col gap-1',
        statSource: 'pt-1'
    },
    variants: {
        columns: {
            2: {
                grid: 'grid-cols-1 @2xl:grid-cols-2'
            },
            3: {
                grid: 'grid-cols-1 @xl:grid-cols-2 @2xl:grid-cols-3'
            },
            4: {
                grid: 'grid-cols-1 @md:grid-cols-2 @4xl:grid-cols-4'
            }
        },
        display: {
            simple: {},
            simpleCenter: {},
            simpleSplit: {},
            withImageCenter: {},
            withImage: {},
            splitWithImage: {}
        }
    },
    compoundVariants: [
        {
            columns: 2,
            display: [
                'simple',
                'simpleCenter'
            ],
            class: {
                gridWrapper: '@2xl:mx-auto @2xl:max-w-1/2'
            }
        },
        {
            columns: 3,
            display: [
                'simple',
                'simpleCenter'
            ],
            class: {
                gridWrapper: '@2xl:mx-auto @2xl:max-w-2/3'
            }
        },
        {
            display: 'simpleCenter',
            class: {
                statItem: 'items-center text-center'
            }
        },
        {
            display: 'withImageCenter',
            class: {
                statItem: 'items-center text-center'
            }
        },
        {
            columns: 2,
            display: [
                'splitWithImage',
                'withImage',
                'withImageCenter',
                'simpleSplit'
            ],
            class: {
                grid: 'grid-cols-1 @md:grid-cols-2'
            }
        }
    ],
    defaultVariants: {
        columns: 4
    }
});
export { moduleStatsVariants };
